import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { DesktopAdminLayout } from '@/components/common/admin/desktop/DesktopAdminLayout';
import { DesktopPageHeader } from '@/components/common/admin/desktop/DesktopPageHeader';
import { SearchBar } from '@/components';
import { EventsCalendar } from '@/components/admin/events/EventsCalendar';
import { DesktopMonthlyEventSelector } from '@/components/admin/events/desktop/DesktopMonthlyEventSelector';
import { DesktopEventDetailsPanel } from '@/components/admin/events/desktop/DesktopEventDetailsPanel';
import { ADMIN_COLORS } from '@/constants/admin';
import { IEvent } from '@/types/admin/events';

interface DesktopEventsViewProps {
  monthlyEvents: IEvent[];
  selectedMonth: Date;
  selectedEvent: IEvent | null;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onMonthChange: (date: Date) => void;
  onSelectEvent: (event: IEvent | null) => void;
  onCreateEvent: () => void;
  onEditEvent: (eventId: number) => void;
}

export const DesktopEventsView: React.FC<DesktopEventsViewProps> = ({
  monthlyEvents,
  selectedMonth,
  selectedEvent,
  searchQuery,
  onSearchChange,
  onMonthChange,
  onSelectEvent,
  onCreateEvent,
  onEditEvent,
}) => {
  const monthName = useMemo(() => selectedMonth.toLocaleString('default', { month: 'long' }), [selectedMonth]);

  return (
    <DesktopAdminLayout>
      <DesktopPageHeader title="Events" subtitle="" showAddButton onAddPress={onCreateEvent} addButtonText="New Event">
        <View style={styles.headerSearch}>
          <SearchBar placeholder="Search" value={searchQuery} onChangeText={onSearchChange} />
        </View>
      </DesktopPageHeader>

      <View style={styles.contentRow}>
        <View style={styles.leftColumn}>
          <View style={styles.calendarCard}>
            <EventsCalendar
              monthlyEvents={monthlyEvents}
              selectedMonth={selectedMonth}
              onMonthChange={onMonthChange}
              onEventSelect={(e) => onSelectEvent(e)}
              onEditEvent={onEditEvent}
              showEventsList={false}
              modalBehavior="none"
            />
          </View>
          <DesktopMonthlyEventSelector 
            monthlyEvents={monthlyEvents}
            monthName={monthName}
            onSelectEvent={(e) => onSelectEvent(e)}
            fill
          />
        </View>

        <View style={styles.rightPanel}>
          <DesktopEventDetailsPanel event={selectedEvent} onEdit={onEditEvent} />
        </View>
      </View>
    </DesktopAdminLayout>
  );
};

const styles = StyleSheet.create({
  headerSearch: {
    minWidth: 260,
  },
  contentRow: {
    flex: 1,
    flexDirection: 'row',
    gap: 16,
    minHeight: 0,
  },
  leftColumn: {
    width: 360,
    minWidth: 360,
    gap: 12,
    minHeight: 0,
  },
  calendarCard: {
    backgroundColor: ADMIN_COLORS.DATA_TABLE.BACKGROUND,
    borderRadius: 8,
  },
  rightPanel: {
    flex: 1,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
    borderRadius: 8,
    overflow: 'hidden',
  },
});


